import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SecurityHelper } from '../pages/common/securityHelper';
import { OfflineQueueService } from './offline-queue.service';
import swal from 'sweetalert2';

declare const window: any;

@Injectable({ providedIn: 'root' })
export class OnlineOfflineService {
  private internalConnectionChanged = new Subject<boolean>();

  private isManuallyOffline = false;

  get connectionChanged() {
    return this.internalConnectionChanged.asObservable();
  }

  get isOnline() {

    let isAppOnline = false;
    let workOffline = SecurityHelper.GetWorkOffline();

    if (!workOffline) {
      isAppOnline = window.navigator.onLine;
    }

    return isAppOnline;
  }
  get isAuthenticated() {
    return SecurityHelper.isAutheticatedWS();
  }

  constructor(public readonly offlineQueue: OfflineQueueService,) {
    window.addEventListener('online', () => this.updateOnlineStatus());
    window.addEventListener('offline', () => this.updateOnlineStatus());
  }

  public updateOnlineStatus() {

    const isOnline = window.navigator.onLine && !this.isManuallyOffline;

    if (isOnline) {
      // require user to login again
      this.offlineQueue.getCountOfflineTransaction();
    }
    this.internalConnectionChanged.next(isOnline);
  }

  public toggleOfflineMode(value: boolean) {

    this.isManuallyOffline = value;
    this.updateOnlineStatus();
  }

  showOfflineWarning() {
    swal
      .fire({
        title: 'Warning',
        html: '<span>You are currently working offline. Data will be available once you get an internet connection.</span>',
        icon: "warning",
        iconColor: "#ffc107",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }

  showOfflineWarningTransaction() {
    swal
      .fire({
        title: 'Warning',
        html: '<span>You are currently working offline. Data cannot be processed at this time.</span>',
        icon: "warning",
        iconColor: "#ffc107",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }
}
